/**
 * @file paddle page get start
 * @author wanzhongyun
 */

import QuickInstall from './../../components/quick-start/QuickStart';
import OnlineExp  from '../onlineExp/OnlineExp';
import { IQuickInstallProps } from './../quick-start/type';
import { IinterOnlineExp, IQuickInstall } from './../../types';
import './style.less';

const GetStart: React.FC<{
    quickStartHooks: IQuickInstallProps;
    quickInstall: IQuickInstall;
    interOnlineExp: IinterOnlineExp;
}> = props => {
    const { quickStartHooks, quickInstall, interOnlineExp } = props;

    return <div className='paddle-inter-page-start'>
        <div className='paddle-inter-page-start-title'>{ quickInstall.title }</div>
        <div className='paddle-inter-page-start-desc'>{ quickInstall.subtitle }</div>
        <QuickInstall {...quickStartHooks} trackeventOptLabel='index Page' />
        <OnlineExp  {...interOnlineExp} />
    </div>
};

export default GetStart;